// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
import '@fortawesome/fontawesome/styles.css'
import fontawesome from '@fortawesome/fontawesome'
import { faCogs } from '@fortawesome/fontawesome-free-solid'
import ElementUI from 'element-ui'
import '../theme/index.css'

fontawesome.library.add(faCogs)

Vue.config.productionTip = false

sync(store, router)

Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js